console.log('Product has bundle')

document.addEventListener('bundler:bundle_widget_created', function(e) {


    // Scroll Button
    const btnsDiv = document.querySelector('.product-form__buttons');
    if(btnsDiv){
        console.log('widget created')

        const bundleButton = document.createElement('button');
        bundleButton.classList.add('custom-scroll-to-bundle','button--large','button--full-width');
        bundleButton.textContent = 'Bundle Me Up & Save!';
        bundleButton.setAttribute('type', 'button'); 

         // Add event listener for scrolling behavior
         bundleButton.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent Shopify from submitting the form

            const bundleSection = document.querySelector('.bndlr-products-container'); // Target the correct element
            if (bundleSection) {
                const offset = 200; // Offset in pixels
                const elementPosition = bundleSection.getBoundingClientRect().top + window.scrollY; // Get element position relative to viewport
                const offsetPosition = elementPosition - offset; // Apply offset

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });


        btnsDiv.prepend(bundleButton);
    }
    // End scroll button

    const bundleDiv = document.querySelector('.bndlr-products-container');
    console.log(bundleDiv)

    if (bundleDiv) {
        const title = bundleDiv.querySelector('.bndlr-bundle-title');
        const description = bundleDiv.querySelector('.bndlr-bundle-description');

        if (title && description) {
            // Create a new wrapper div
            const wrapperDiv = document.createElement('div');
            wrapperDiv.classList.add('top-text'); 

           bundleDiv.prepend(wrapperDiv)

            // Move title and description inside the wrapper
            wrapperDiv.appendChild(title);
            wrapperDiv.appendChild(description);
        }
    }
    
});